<div class="listCoins animate__animated animate__fadeIn">

  <ul class="coinsMenu">
    <li [ngClass]="{ 'active': promotedVisible}" (click)="scrollToElement(promoted)" class="promoted"><img src="/assets/images/icons/star.svg" alt=""></li>
    <li [ngClass]="{ 'active': topVisible}" (click)="scrollToElement(top)" class="top"><img src="/assets/images/icons/podium.svg" alt=""></li>
    <li [ngClass]="{ 'active': newVisible}" (click)="scrollToElement(new)" class="new"><img src="/assets/images/icons/trend.svg" alt=""></li>
  </ul>

  <p *ngIf="successMessage" class="successMessage">
    {{ successMessage }}
  </p>
  <div id="promotedTarget" style="scroll-margin: 70px;" #promoted></div>
  <div class="featuredCoins">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <h1>
          Featured coins
          <span class="promote">
            <a routerLink="/advertise">Promote your coin!</a>
          </span>
        </h1>
      </div>
    </div>

    <div class="mobileTable mobileTableFeatured">
      <ul class="header">
        <li class="w10">#</li>
        <li class="w40">Name</li>
        <li class="w20">Votes</li>
        <li class="w30">Vote</li>
      </ul>
      <ul (click)="navigate(coin)" *ngFor="let coin of featuredCoins; let index = index; trackBy:trackByIndex;" [ngClass]="{'one': index%2 == 0, 'two': index%2 != 0}" class="body">
        <li class="w10">{{ index+1 }}</li>
        <li class="w40">
          <div style="text-align: center;">
            <img class="logo" [defaultImage]="'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADIAQMAAACXljzdAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAAcSURBVHic7cGBAAAAAMOg+VNf4QBVAQAAAAB8BhRQAAHaoBD5AAAAAElFTkSuQmCC'" [lazyLoad]="'https://api.coincatapult.com/storage/images/logo/'+coin.logo" onError="this.style.display = 'none'" alt="Image">
            <span>
              <span class="name">
                {{ coin.name }}
              </span>
              <span class="network">
                <img class="network" *ngIf="coin.network == 'bsc'" src="assets/images/icons/bsc.svg" alt="BSC">
                <img class="network" *ngIf="coin.network == 'sui'" src="assets/images/icons/sui.svg" alt="SUI">
                <img class="network eth" *ngIf="coin.network == 'eth'" src="assets/images/icons/eth.svg" alt="Ethereum">
                <img class="network" *ngIf="coin.network == 'tron'" src="assets/images/icons/tron.png" alt="TRON">
                <img class="network" *ngIf="coin.network == 'harmony'" src="assets/images/icons/harmony.svg" alt="Harmony">
                <img class="network" *ngIf="coin.network == 'polygon'" src="assets/images/icons/polygon.svg" alt="Polygon">
                <img class="network" *ngIf="coin.network == 'algorand'" src="assets/images/icons/algorand.svg" alt="Algorand">
                <img class="network" *ngIf="coin.network == 'solana'" src="assets/images/icons/solana.svg" alt="Solana">
                <img class="network" *ngIf="coin.network == 'base'" src="assets/images/icons/base.svg" alt="Base">
              </span>
            </span>
            <span class="symbol">
              {{ coin.symbol }}
            </span>
            <div class="smallImagesMobile">
              <a rel="nofollow noopener" *ngIf="coin.tmp && coin.tmp.cmc" title="View on CoinMarketCap" target="_blank" href="https://coinmarketcap.com/currencies/{{ coin.tmp.cmc }}">
                <img src="assets/images/coinmarketcap.png" alt="View on CoinMarketCap">
              </a>
              <a rel="nofollow noopener" *ngIf="coin.tmp && coin.tmp.cg" title="View on CoinGecko" target="_blank" href="https://www.coingecko.com/en/coins/{{ coin.tmp.cg }}">
                <img src="assets/images/coingecko.png" alt="View on CoinGecko">
              </a>
            </div>
          </div>
        </li>
        <li class="w20"><span class="coinVotesCount">{{ coin.votes }}</span></li>
        <li class="w30">
          <button [disabled]="coin.timeToVote > 0" class="btn btn-primary-custom">
            <span>
              <span *ngIf="!coin.timeToVote">Vote</span> <span *ngIf="coin.timeToVote > 0"><countdown [config]="{leftTime: coin.timeToVote, format: 'HH:mm:ss'}" (event)="handleEventList($event, coin)"></countdown></span>
            </span>
          </button>
        </li>
      </ul>
    </div>

    <div class="table-responsive featuredTable">
      <table class="table">
        <thead>
          <tr>
            <th class="radiusLT" scope="col">#</th>
            <th scope="col"></th>
            <th scope="col">Name</th>
            <th scope="col">Chain</th>
            <th scope="col">Symbol</th>
            <th scope="col">Votes</th>
            <th scope="col">Launch date</th>
            <th class="radiusRT" scope="col">Vote</th>
          </tr>
        </thead>
        <tbody style="background-color: #21252b;">
          <tr (click)="navigate(coin)" *ngFor="let coin of featuredCoins; let index = index; trackBy:trackByIndex;" [ngClass]="{'one': index%2 == 0, 'two': index%2 != 0}">
            <th class="radiusLB" scope="row">{{ index + 1 }}</th>
            <td class="v-align">
              <img [defaultImage]="'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADIAQMAAACXljzdAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAAcSURBVHic7cGBAAAAAMOg+VNf4QBVAQAAAAB8BhRQAAHaoBD5AAAAAElFTkSuQmCC'" [lazyLoad]="'https://api.coincatapult.com/storage/images/logo/'+coin.logo" alt="Image">

              <div class="smallImages">
                <a rel="nofollow noopener" *ngIf="coin.tmp && coin.tmp.cmc" title="View coinmarketcap" target="_blank" href="https://coinmarketcap.com/currencies/{{ coin.tmp.cmc }}">
                  <img src="assets/images/coinmarketcap.png" alt="View on coinmarketcap">
                </a>
                <a rel="nofollow noopener" *ngIf="coin.tmp && coin.tmp.cg" title="View oncoingecko" target="_blank" href="https://www.coingecko.com/en/coins/{{ coin.tmp.cg }}">
                  <img src="assets/images/coingecko.png" alt="View on coingecko">
                </a>
              </div>
            </td>
            <td>{{ coin.name }}</td>
            <td>
              <img class="network" *ngIf="coin.network == 'bsc'" src="assets/images/icons/bsc.svg" alt="BSC">
              <img class="network" *ngIf="coin.network == 'sui'" src="assets/images/icons/sui.svg" alt="SUI">
              <img class="network eth" *ngIf="coin.network == 'eth'" src="assets/images/icons/eth.svg" alt="Ethereum">
              <img class="network" *ngIf="coin.network == 'tron'" src="assets/images/icons/tron.png" alt="TRON">
              <img class="network" *ngIf="coin.network == 'harmony'" src="assets/images/icons/harmony.svg" alt="Harmony">
              <img class="network" *ngIf="coin.network == 'polygon'" src="assets/images/icons/polygon.svg" alt="Polygon">
              <img class="network" *ngIf="coin.network == 'algorand'" src="assets/images/icons/algorand.svg" alt="Algorand">
              <img class="network" *ngIf="coin.network == 'solana'" src="assets/images/icons/solana.svg" alt="Solana">
              <img class="network" *ngIf="coin.network == 'base'" src="assets/images/icons/base.svg" alt="Base">
            </td>
            <td>{{ coin.symbol }}</td>
            <td><span class="coinVotesCount">{{ coin.votes }}</span></td>
            <td>
              {{ coin.launch_date }}
            </td>
            <td class="radiusRB">
              <button [disabled]="coin.timeToVote > 0" class="btn btn-primary-custom">
                <span>
                  <span *ngIf="!coin.timeToVote">Vote</span> <span *ngIf="coin.timeToVote > 0"><countdown [config]="{leftTime: coin.timeToVote, format: 'HH:mm:ss'}" (event)="handleEventList($event, coin)"></countdown></span>
                </span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div id="topTarget" style="scroll-margin: 20px;" #top></div>
  <div class="featuredCoins allCoins">
    <h2>
      Top coins
      <span class="promote">
        <a routerLink="/add-coin">List your coin!</a>
      </span>
    </h2>

    <ul class="orderButtons">
      <li class="orderBy">Order By:</li>
      <li (click)="changeOrder('votes')" class="button" [ngClass]="{'active': topCoinsOrder == 'votes'}">Total votes</li>
      <li (click)="changeOrder('votesToday')" class="button" [ngClass]="{'active': topCoinsOrder == 'votesToday'}">Votes today</li>
    </ul>
    <div *ngIf="orderChanged" class="mobileTable">
      <ul class="header">
        <li class="w10">#</li>
        <li class="w40">Name</li>
        <li class="w20">
          <span *ngIf="topCoinsOrder == 'votes'">
            Votes
          </span>
          <span *ngIf="topCoinsOrder == 'votesToday'">
            Votes today
          </span>
        </li>
        <li class="w30">Vote</li>
      </ul>
      <ul (click)="navigate(coin)" *ngFor="let coin of coins | sortBy:'desc':topCoinsOrder | slice:0:topLimit; let index = index; trackBy:trackByIndex;" [ngClass]="{'one': index%2 == 0, 'two': index%2 != 0}" class="body">
        <li class="w10">{{ (p-1) * 50 + index + 1 }}</li>
        <li class="w40">
          <div style="text-align: center;">
            <img [defaultImage]="'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADIAQMAAACXljzdAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAAcSURBVHic7cGBAAAAAMOg+VNf4QBVAQAAAAB8BhRQAAHaoBD5AAAAAElFTkSuQmCC'" class="logo" [lazyLoad]="'https://api.coincatapult.com/storage/images/logo/'+coin.logo" onError="this.style.display = 'none'" alt="Image">
            <span>
              <span class="name">
                {{ coin.name }}
              </span>
              <span class="network">
                <img class="network" *ngIf="coin.network == 'bsc'" src="assets/images/icons/bsc.svg" alt="BSC">
                <img class="network" *ngIf="coin.network == 'sui'" src="assets/images/icons/sui.svg" alt="SUI">
                <img class="network eth" *ngIf="coin.network == 'eth'" src="assets/images/icons/eth.svg" alt="Ethereum">
                <img class="network" *ngIf="coin.network == 'tron'" src="assets/images/icons/tron.png" alt="TRON">
                <img class="network" *ngIf="coin.network == 'harmony'" src="assets/images/icons/harmony.svg" alt="Harmony">
                <img class="network" *ngIf="coin.network == 'polygon'" src="assets/images/icons/polygon.svg" alt="Polygon">
                <img class="network" *ngIf="coin.network == 'algorand'" src="assets/images/icons/algorand.svg" alt="Algorand">
                <img class="network" *ngIf="coin.network == 'solana'" src="assets/images/icons/solana.svg" alt="Solana">
                <img class="network" *ngIf="coin.network == 'base'" src="assets/images/icons/base.svg" alt="Base">
              </span>
            </span>
            <span class="symbol">
              {{ coin.symbol }}
            </span>
            <div class="smallImagesMobile">
              <a rel="nofollow noopener" *ngIf="coin.tmp && coin.tmp.cmc" title="View coinmarketcap" target="_blank" href="https://coinmarketcap.com/currencies/{{ coin.tmp.cmc }}">
                <img src="assets/images/coinmarketcap.png" alt="View on coinmarketcap">
              </a>
              <a rel="nofollow noopener" *ngIf="coin.tmp && coin.tmp.cg" title="View oncoingecko" target="_blank" href="https://www.coingecko.com/en/coins/{{ coin.tmp.cg }}">
                <img src="assets/images/coingecko.png" alt="View on coingecko">
              </a>
            </div>
          </div>
        </li>
        <li class="w20">
          <span class="coinVotesCount">
            <span *ngIf="topCoinsOrder == 'votes'">
              {{ coin.votes }}
            </span>
            <span *ngIf="topCoinsOrder == 'votesToday'">
              {{ coin.votesToday }}
            </span>
          </span>
        </li>
        <li class="w30">
          <button [disabled]="coin.timeToVote > 0" class="btn btn-primary-custom">
            <span>
              <span *ngIf="!coin.timeToVote">Vote</span> <span *ngIf="coin.timeToVote > 0"><countdown [config]="{leftTime: coin.timeToVote, format: 'HH:mm:ss'}" (event)="handleEventList($event, coin)"></countdown></span>
            </span>
          </button>
        </li>
      </ul>
      <ul *ngIf="coins.length > topLimit" (click)="topLoadMore()" class="loadMore body">
        <li class="w100"><p><i class="fa fa-chevron-down"></i> Load more</p></li>
      </ul>
    </div>

    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th class="radiusLT" scope="col">#</th>
            <th scope="col"></th>
            <th scope="col">Name</th>
            <th scope="col">Chain</th>
            <th scope="col">Symbol</th>
            <th scope="col">
               <span *ngIf="topCoinsOrder == 'votes'">
                  Votes
               </span>
               <span *ngIf="topCoinsOrder == 'votesToday'">
                  Votes today
               </span>
            </th>
            <th scope="col">Launch date</th>
            <th class="radiusRT" scope="col">Vote</th>
          </tr>
        </thead>
        <tbody>
          <tr (click)="navigate(coin)" *ngFor="let coin of coins | sortBy:'desc':topCoinsOrder | slice:0:topLimit; let index = index; trackBy:trackByIndex;" [ngClass]="{'one': index%2 == 0, 'two': index%2 != 0}">
            <th class="radiusLB" scope="row">{{ (p-1) * 50 + index + 1 }}</th>
            <td class="v-align">
              <img [defaultImage]="'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADIAQMAAACXljzdAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAAcSURBVHic7cGBAAAAAMOg+VNf4QBVAQAAAAB8BhRQAAHaoBD5AAAAAElFTkSuQmCC'" [lazyLoad]="'https://api.coincatapult.com/storage/images/logo/'+coin.logo" onError="this.style.display = 'none'" alt="Image">
              <div class="smallImages">
                <a rel="nofollow noopener" *ngIf="coin.tmp && coin.tmp.cmc" title="View coinmarketcap" target="_blank" href="https://coinmarketcap.com/currencies/{{ coin.tmp.cmc }}">
                  <img src="assets/images/coinmarketcap.png" alt="View on coinmarketcap">
                </a>
                <a rel="nofollow noopener" *ngIf="coin.tmp && coin.tmp.cg" title="View oncoingecko" target="_blank" href="https://www.coingecko.com/en/coins/{{ coin.tmp.cg }}">
                  <img src="assets/images/coingecko.png" alt="View on coingecko">
                </a>
              </div>
            </td>
            <td>{{ coin.name }}</td>
            <td>
              <img class="network" *ngIf="coin.network == 'bsc'" src="assets/images/icons/bsc.svg" alt="BSC">
              <img class="network" *ngIf="coin.network == 'sui'" src="assets/images/icons/sui.svg" alt="SUI">
              <img class="network eth" *ngIf="coin.network == 'eth'" src="assets/images/icons/eth.svg" alt="Ethereum">
              <img class="network" *ngIf="coin.network == 'tron'" src="assets/images/icons/tron.png" alt="TRON">
              <img class="network" *ngIf="coin.network == 'harmony'" src="assets/images/icons/harmony.svg" alt="Harmony">
              <img class="network" *ngIf="coin.network == 'polygon'" src="assets/images/icons/polygon.svg" alt="Polygon">
              <img class="network" *ngIf="coin.network == 'algorand'" src="assets/images/icons/algorand.svg" alt="Algorand">
              <img class="network" *ngIf="coin.network == 'solana'" src="assets/images/icons/solana.svg" alt="Solana">
              <img class="network" *ngIf="coin.network == 'base'" src="assets/images/icons/base.svg" alt="Base">
            </td>
            <td>{{ coin.symbol }}</td>
            <td>
              <span class="coinVotesCount">
                <span *ngIf="topCoinsOrder == 'votes'">
                  {{ coin.votes }}
                </span>
                <span *ngIf="topCoinsOrder == 'votesToday'">
                  {{ coin.votesToday }}
                </span>
              </span>
            </td>
            <td>
              {{ coin.launch_date }}
            </td>
            <td class="radiusRB">
              <button [disabled]="coin.timeToVote > 0" class="btn btn-primary-custom">
                <span>
                  <span *ngIf="!coin.timeToVote">Vote</span> <span *ngIf="coin.timeToVote > 0"><countdown [config]="{leftTime: coin.timeToVote, format: 'HH:mm:ss'}" (event)="handleEventList($event, coin)"></countdown></span>
                </span>
              </button>
            </td>
          </tr>
          <tr *ngIf="coins.length > topLimit" (click)="topLoadMore()" class="loadMore">
            <td colspan="8"><p><i class="fa fa-chevron-down"></i> Load more</p></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div id="newTarget" style="scroll-margin: 20px;" #new></div>
  <div class="featuredCoins allCoins">
    <h2>
      New coins
      <span class="promote">
        <a routerLink="/add-coin">List your coin!</a>
      </span>
    </h2>

    <ul class="orderButtons">
      <li class="orderBy">Order By:</li>
      <li (click)="newCoinsOrder = 'votes'" class="button" [ngClass]="{'active': newCoinsOrder == 'votes'}">Total votes</li>
      <li (click)="newCoinsOrder = 'created_at'" class="button" [ngClass]="{'active': newCoinsOrder == 'created_at'}">Most recent</li>
    </ul>

    <div class="mobileTable">
      <ul class="header">
        <li class="w10">#</li>
        <li class="w40">Name</li>
        <li class="w20">Votes</li>
        <li class="w30">Vote</li>
      </ul>
      <ul (click)="navigate(coin)" *ngFor="let coin of newCoins | sortBy:'desc':newCoinsOrder | slice:0:newLimit; let index = index; trackBy:trackByIndex;" [ngClass]="{'one': index%2 == 0, 'two': index%2 != 0}" class="body">
        <li class="w10">{{ (p-1) * 50 + index + 1 }}</li>
        <li class="w40">
          <div style="text-align: center;">
            <img [defaultImage]="'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADIAQMAAACXljzdAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAAcSURBVHic7cGBAAAAAMOg+VNf4QBVAQAAAAB8BhRQAAHaoBD5AAAAAElFTkSuQmCC'" class="logo" [lazyLoad]="'https://api.coincatapult.com/storage/images/logo/'+coin.logo" onError="this.style.display = 'none'" alt="Image">
            <span>
              <span class="name">
                {{ coin.name }}
              </span>
              <span class="network">
              <img class="network" *ngIf="coin.network == 'bsc'" src="assets/images/icons/bsc.svg" alt="BSC">
                <img class="network" *ngIf="coin.network == 'sui'" src="assets/images/icons/sui.svg" alt="SUI">
              <img class="network eth" *ngIf="coin.network == 'eth'" src="assets/images/icons/eth.svg" alt="Ethereum">
              <img class="network" *ngIf="coin.network == 'tron'" src="assets/images/icons/tron.png" alt="TRON">
              <img class="network" *ngIf="coin.network == 'harmony'" src="assets/images/icons/harmony.svg" alt="Harmony">
              <img class="network" *ngIf="coin.network == 'polygon'" src="assets/images/icons/polygon.svg" alt="Polygon">
              <img class="network" *ngIf="coin.network == 'algorand'" src="assets/images/icons/algorand.svg" alt="Algorand">
              <img class="network" *ngIf="coin.network == 'solana'" src="assets/images/icons/solana.svg" alt="Solana">
              <img class="network" *ngIf="coin.network == 'base'" src="assets/images/icons/base.svg" alt="Base">
              </span>
            </span>
            <span class="symbol">
              {{ coin.symbol }}
            </span>
            <div class="smallImagesMobile">
              <a rel="nofollow noopener" *ngIf="coin.tmp && coin.tmp.cmc" title="View coinmarketcap" target="_blank" href="https://coinmarketcap.com/currencies/{{ coin.tmp.cmc }}">
                <img src="assets/images/coinmarketcap.png" alt="View on coinmarketcap">
              </a>
              <a rel="nofollow noopener" *ngIf="coin.tmp && coin.tmp.cg" title="View oncoingecko" target="_blank" href="https://www.coingecko.com/en/coins/{{ coin.tmp.cg }}">
                <img src="assets/images/coingecko.png" alt="View on coingecko">
              </a>
            </div>
          </div>
        </li>
        <li class="w20"><span class="coinVotesCount">{{ coin.votes }}</span></li>
        <li class="w30">
          <button [disabled]="coin.timeToVote > 0" class="btn btn-primary-custom">
            <span>
              <span *ngIf="!coin.timeToVote">Vote</span> <span *ngIf="coin.timeToVote > 0"><countdown [config]="{leftTime: coin.timeToVote, format: 'HH:mm:ss'}" (event)="handleEventList($event, coin)"></countdown></span>
            </span>
          </button>
        </li>
      </ul>
      <ul *ngIf="newCoins.length > newLimit" (click)="newLoadMore()" class="loadMore body">
        <li class="w100"><p><i class="fa fa-chevron-down"></i> Load more</p></li>
      </ul>
    </div>

    <div class="table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th class="radiusLT" scope="col">#</th>
          <th scope="col"></th>
          <th scope="col">Name</th>
          <th scope="col">Chain</th>
          <th scope="col">Symbol</th>
          <th scope="col">Votes</th>
          <th scope="col">Launch date</th>
          <th class="radiusRT" scope="col">Vote</th>
        </tr>
        </thead>
        <tbody>
        <tr (click)="navigate(coin)" *ngFor="let coin of newCoins | sortBy:'desc':newCoinsOrder | slice:0:newLimit; let index = index; trackBy:trackByIndex;" [ngClass]="{'one': index%2 == 0, 'two': index%2 != 0}">
          <th class="radiusLB" scope="row">{{ (p-1) * 50 + index + 1 }}</th>
          <td class="v-align">
            <img [defaultImage]="'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADIAQMAAACXljzdAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAAcSURBVHic7cGBAAAAAMOg+VNf4QBVAQAAAAB8BhRQAAHaoBD5AAAAAElFTkSuQmCC'" [lazyLoad]="'https://api.coincatapult.com/storage/images/logo/'+coin.logo" onError="this.style.display = 'none'" alt="Image">
            <div class="smallImages">
              <a rel="nofollow noopener" *ngIf="coin.tmp && coin.tmp.cmc" title="View coinmarketcap" target="_blank" href="https://coinmarketcap.com/currencies/{{ coin.tmp.cmc }}">
                <img src="assets/images/coinmarketcap.png" alt="View on coinmarketcap">
              </a>
              <a rel="nofollow noopener" *ngIf="coin.tmp && coin.tmp.cg" title="View oncoingecko" target="_blank" href="https://www.coingecko.com/en/coins/{{ coin.tmp.cg }}">
                <img src="assets/images/coingecko.png" alt="View on coingecko">
              </a>
            </div>
          </td>
          <td>{{ coin.name }}</td>
          <td>
            <img class="network" *ngIf="coin.network == 'bsc'" src="assets/images/icons/bsc.svg" alt="BSC">
            <img class="network" *ngIf="coin.network == 'sui'" src="assets/images/icons/sui.svg" alt="SUI">
            <img class="network eth" *ngIf="coin.network == 'eth'" src="assets/images/icons/eth.svg" alt="Ethereum">
            <img class="network" *ngIf="coin.network == 'tron'" src="assets/images/icons/tron.png" alt="TRON">
            <img class="network" *ngIf="coin.network == 'harmony'" src="assets/images/icons/harmony.svg" alt="Harmony">
            <img class="network" *ngIf="coin.network == 'polygon'" src="assets/images/icons/polygon.svg" alt="Polygon">
            <img class="network" *ngIf="coin.network == 'algorand'" src="assets/images/icons/algorand.svg" alt="Algorand">
            <img class="network" *ngIf="coin.network == 'solana'" src="assets/images/icons/solana.svg" alt="Solana">
            <img class="network" *ngIf="coin.network == 'base'" src="assets/images/icons/base.svg" alt="Base">
          </td>
          <td>{{ coin.symbol }}</td>
          <td><span class="coinVotesCount">{{ coin.votes }}</span></td>
          <td>
            {{ coin.launch_date }}
          </td>
          <td class="radiusRB">
            <button [disabled]="coin.timeToVote > 0" class="btn btn-primary-custom">
                <span>
                  <span *ngIf="!coin.timeToVote">Vote</span> <span *ngIf="coin.timeToVote > 0"><countdown [config]="{leftTime: coin.timeToVote, format: 'HH:mm:ss'}" (event)="handleEventList($event, coin)"></countdown></span>
                </span>
            </button>
          </td>
        </tr>
        <tr *ngIf="newCoins.length > newLimit" (click)="newLoadMore()" class="loadMore">
          <td colspan="8"><p><i class="fa fa-chevron-down"></i> Load more</p></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>

<div *ngIf="loading" class="loader">
  <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
</div>
